import { Component, Input } from '@angular/core';
import { BaseCellComponent } from '../base-cell.component';
import { ViewManager } from 'src/app/board/pages/admin/admin-components/custom-views-config/view-builder/models/view-builder.models';

@Component({
  selector: 'bhub-pdf-checkbox-cell',
  standalone: false,
  templateUrl: './pdf-checkbox-cell.component.html',
  styleUrls: ['./pdf-checkbox-cell.component.scss']
})
export class PdfCheckboxCellComponent extends BaseCellComponent {
  @Input() viewManager: ViewManager | null = null;

  checked = false;
  label = '';
  boxSize = 14;
  fontSize = 12;
  fontWeight = 'normal';
  fontStyle = 'normal';
  color = '#000000';
  boxColor = '#000000';
  checkColor = '#000000';
  borderThickness = 1;
  gap = 4;

  toggleChecked(): void {
    if (this.isEditMode) return;
    this.checked = !this.checked;
    this.cell.configuration.pdfCheckboxChecked = this.checked;
  }

  protected initializeCell(): void { this.update(); }
  protected onCellOrDataChange(): void { this.update(); }
  protected onCellUpdate(): void { this.update(); }
  protected onDataSet(data: any): void { this.update(); }
  reloadData(): void { this.update(); }

  private update(): void {
    if (!this.cell) return;

    this.label = this.getConfigValue('pdfCheckboxLabel', '');
    this.boxSize = this.getConfigValue('pdfCheckboxBoxSize', 14);
    this.fontSize = this.getConfigValue('pdfFontSize', 12);
    this.fontWeight = this.getConfigValue('pdfFontWeight', 'normal');
    this.fontStyle = this.getConfigValue('pdfFontStyle', 'normal');
    this.color = this.getConfigValue('pdfColor', '#000000');
    this.boxColor = this.getConfigValue('pdfCheckboxBoxColor', '#000000');
    this.checkColor = this.getConfigValue('pdfCheckboxCheckColor', '#000000');
    this.borderThickness = this.getConfigValue('pdfCheckboxBorderThickness', 1);
    this.gap = this.getConfigValue('pdfCheckboxGap', 4);

    // Resolve checked state: from context if configured, otherwise static
    const contextVariable = this.getConfigValue('pdfCheckboxContextVariable', '');
    const fieldName = this.getConfigValue('pdfCheckboxFieldName', '');

    if (contextVariable && fieldName && this.viewManager?.contextData) {
      const contextObj = this.viewManager.contextData[contextVariable];
      if (contextObj) {
        const value = Array.isArray(contextObj) && contextObj.length > 0
          ? contextObj[0][fieldName]
          : contextObj[fieldName];
        this.checked = !!value;
      } else {
        this.checked = this.getConfigValue('pdfCheckboxChecked', false);
      }
    } else {
      this.checked = this.getConfigValue('pdfCheckboxChecked', false);
    }
  }
}
